<template>
  <div class="table-header">
    <table-operation v-bind="$attrs" />
  </div>
</template>

<script>
import TableOperation from '@/components/tableHeader/tableOperation'
export default {
  name: 'table-header',
  props: {
    onlyOperation: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {}
  },
  components: {
    TableOperation
  },
  methods: {
    sceneClickHandle (val) {
      this.$emit('sceneChange', val)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/style/table.scss'
</style>